import { Center, CenterProps } from "@chakra-ui/react";

export const MobileMenuIcon = ({ ...rest }: CenterProps) => {
  return (
    <Center color="#393B3E" {...rest}>
      <svg
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="1" x2="15" y2="1" stroke="currentColor" strokeWidth="2" />
        <line y1="6" x2="15" y2="6" stroke="currentColor" strokeWidth="2" />
        <line y1="11" x2="15" y2="11" stroke="currentColor" strokeWidth="2" />
      </svg>
    </Center>
  );
};
